module.exports = __webpack_public_path__ + "static/media/31JFA8.ec21b2fc.jpg";